/** @jsxImportSource @emotion/react */

import { BG_MAIN } from "assets/Common";
import Footer from "components/Common/Footer";
import { Header } from "components/Desktop/ui/Header";
import UserMenuSidebar from "components/Desktop/ui/UserMenuSidebar";
import { Outlet } from "react-router";

import { UserLayoutStyle } from "./index.style";

const UserLayout = () => {
  return (
    <div css={UserLayoutStyle.self}>
      <Header />
      <div css={UserLayoutStyle.contentWrapper}>
        <UserMenuSidebar />
        <main css={UserLayoutStyle.mainContent}>
          <Outlet />
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default UserLayout;
